var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"splash-screen",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/img/logo/splash.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }